export default "__VITE_ASSET__Ln8F$68P__"